import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { checkSession } from '../store/slices/authSlice';
import { LoadingScreen } from './LoadingScreen';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isCheckingSession } = useAppSelector(state => state.auth);

  useEffect(() => {
    dispatch(checkSession());
  }, [dispatch]);

  if (isCheckingSession) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
